export default class ParkingDetails {
    created: Date | null = null
    releaseVersion: number | null = null;
    total: number | null = null;
    employeeParking: number | null = null;
    disabledParking: number | null = null;
    visitorParking: number | null = null;
    ogvParking: number | null = null;
    ogvLoadingBays: number | null = null;
    cycleRacks: number | null = null;
    parentToddler: number | null = null;
    motorcycleSpaces: number | null = null;
    electricChargingBays: number | null = null;
    onStreetSpaces: number | null = null;
    drivewaySpaces: number | null = null;
    garageSpaces: number | null = null;
    communalSpaces: number | null = null;
    allocatedSpaces: number | null = null;
    noOnSiteParking: boolean | null = null;
    parkingCharges: string | null = null;
    managementComments: string | null = null;
    siteParkingSurface: string | null = null;
    generalComments: string | null = null;
    onSiteServicing: string | null = null;
    parkingRestrictionsTimeLimited: string | null = null;

    onStreetParkingWithinCPZ: string | null = null;
    onStreetParkingCharges: number | null = null;
    onStreetMaxParkingDuration: number | null = null;

    offSiteServicing: string | null = null;
    restrictedOffSiteServicing: string | null = null;
    offSiteParkingAvailable: string | null = null;
    offSiteParkingIncludedInCount: string | null = null;
    offStreetParkingAvailable: string | null = null;
    offStreetParkingWithinCPZ: string | null = null;
    offStreetParkingCharges: string | null = null;
    offStreetParkingChargesAmount: number | null = null;
    offStreetParkingPeriod: string | null = null;
    offStreetParkingApproxSpaces: number | null = null;
    freeOnStreetParkingAvailable: string | null = null;
    freeOnStreetParkingEasyToFindSpace: string | null = null;
    preparedToPayEasyToFindSpace: string | null = null;
    parkingRestrictions: string | null = null;
    parkingRestrictionsCPZNonResident: string | null = null;
    parkAndRide: string | null = null;
    parkAndRideJourney: number | null = null;
    carClub: string | null = null;
    serviceVehiclesParkWithinSite: boolean | null = null;
    serviceVehiclesParkOutsideSiteDesignatedAreas: boolean | null = null;
    serviceVehiclesParkOutsideSiteRestrictedAreas: boolean | null = null;

    totPar1Calc: number | null = null;
    totPar2Calc: number | null = null;
    totPar1Label: string | null = null;
    totPar2Label: string | null = null;
    totPar1Value: string | null = null;
    totPar2Value: string | null = null;

    hasServicing: boolean = false;

    parkingVersion: string | null = null;

    // version 2
    offSiteParkingPossible: boolean | null = null;
    freeWithoutRestrictions: boolean | null = null;
    includedInSurveyCounts: boolean | null = null;
    offSiteAdditionalComments: string | null = null;
    freeUnrestrictedAvailable: boolean | null = null;
    restrictionsWithinArea: boolean | null = null;
    nonResidentPermitted: boolean | null = null;
    timeLimitExists: boolean | null = null;
    timeLimitMinutes: number | null = null;
    parkingCharged: boolean | null = null;
    minChargePerHour: number | null = null;
    offSiteParkingAvailableWithinWalkingDistance: boolean | null = null;
    publicCarParksChargedSpaces: number | null = null;
    publicCarParksFreeSpaces: number | null = null;
    publicCarParksTotalSpaces: number | null = null;
    publicCarParksMinHourlyCharge: number | null = null;
    otherDevelopmentsChargedSpaces: number | null = null;
    otherDevelopmentsFreeSpaces: number | null = null;
    otherDevelopmentsTotalSpaces: number | null = null;
    otherDevelopmentsMinHourlyCharge: number | null = null;
    offSiteProvidedChargedSpaces: number | null = null;
    offSiteProvidedFreeSpaces: number | null = null;
    offSiteProvidedTotalSpaces: number | null = null;
    offSiteProvidedMinHourlyCharge: number | null = null;
    parkRideChargedSpaces: number | null = null;
    parkRideFreeSpaces: number | null = null;
    parkRideTotalSpaces: number | null = null;
    parkRideMinHourlyCharge: number | null = null;
    otherOffSiteChargedSpaces: number | null = null;
    otherOffSiteFreeSpaces: number | null = null;
    otherOffSiteTotalSpaces: number | null = null;
    otherOffSiteMinHourlyCharge: number | null = null;
}
